import {
  ChatIcon,
  FinanceIcon,
  GridIcon,
  HistoryIcon,
  ListIcon,
  PeopleIcon,
  SearchIcon,
} from "../../../../../assets/icons";
import { NavItemData } from "./types";

export const navItemData: Array<NavItemData> = [
  {
    title: "داشبورد",
    to: "/",
    Icon: ListIcon,
  },
  {
    title: "ادمین پنل",
    to: "/admin",
    Icon: GridIcon,
  },
  {
    title: "مشتریان",
    to: "/customers",
    Icon: PeopleIcon,
  },
  {
    title: "پیام ها",
    to: "/chat",
    Icon: ChatIcon,
  },
  {
    title: "جستجو",
    to: "/search",
    Icon: SearchIcon,
  },
  {
    title: "تاریخچه",
    to: "/history",
    Icon: HistoryIcon,
  },
  {
    title: "مالی",
    to: "/financial",
    Icon: FinanceIcon,
  },
];
